<h3 [style]="titleAndTextStyles()">{{ title() }}</h3>

@if (dismissable()) {
  <i class="fas fa-times dismiss-icon" (click)="onDismiss.emit()"></i>
}

<div class="text-and-link-container">
  <span [style]="titleAndTextStyles()" class="v-align-middle notification-text" [innerHTML]="text() ? text() : ''"></span>

  @if (hasButton()) {
    <p-button class="v-align-middle" [link]="true" styleClass="text-sm {{ newLineButtonClass() }}" [label]="buttonText()" (click)="buttonClick.emit()" />
  }
</div>
